import styled from 'styled-components'

import mediaQueries from 'components/media-queries'

/** All these styles are shared by components/autosuggestion */
const getBorderColor = ({ inputFocus, error, flatStyle, theme }) => {
  if (inputFocus) {
    return theme.colors.blue
  }

  if (error) {
    return theme.colors.red
  }

  if (flatStyle) {
    return theme.colors.veryLightPink
  }

  return theme.colors.transparent
}

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  border: 1px solid ${props => getBorderColor(props)};
  border-radius: 3px;
  padding: 1px;

  ${({ flatStyle, theme }) =>
    !flatStyle &&
    `box-shadow: 0 2px 10px 0 ${theme.shadow.black26}, 0 2px 5px 0 ${theme.shadow.black06};`};

  ${({ inputFocus, flatStyle, theme }) =>
    inputFocus && flatStyle && `box-shadow: 0 2px 4px 0 ${theme.shadow.black09};`};
`

export const Container = styled.div.attrs(props => ({
  className: `field-${props.name}` || ''
}))`
  .react-autosuggest__container {
    background-color: ${({ theme }) => theme.colors.white};
  }
  .react-autosuggest__input {
    outline: 0;
    border: none;
    border-radius: 3px;
    padding: 13px;
    opacity: ${({ isLoading }) => (isLoading ? '0.6' : 'inherit')};
    padding-left: 45px;
    font-size: 16px;
    font-family: ${({ theme }) => theme.fonts.regular};
    width: 100%;
    letter-spacing: 0.3px;
    border-radius: 3px;
    color: ${({ theme }) => theme.colors.blueDark};
    ${({ light }) =>
      light &&
      `
      font-size: 14px;
    `};
    ${mediaQueries.tablet`
      ${({ light }) =>
        light &&
        `
        padding-left: 29px;
        letter-spacing: 0.26px;
      `};
    `};
  }

  .react-autosuggest__input::-ms-clear {
    display: none;
  }

  .react-autosuggest__suggestions-container {
    display: none;
  }

  .react-autosuggest__suggestions-container--open {
    display: block;
    position: absolute;
    width: auto;
    min-width: 330px;
    border-radius: 3px;
    ${({ theme }) => `
      box-shadow: 0 2px 10px 0 ${theme.shadow.black06}, 0 2px 5px 0 ${theme.shadow.black26};
    `};
    background-color: ${({ theme }) => theme.colors.white};
    border: solid 1px ${({ theme }) => theme.colors.blue};
    margin-top: 4px;
    z-index: 2;
    font-family: ${({ theme }) => theme.fonts.regular};

    ${mediaQueries.tablet`
      width: 100%;
      min-width: auto;
    `};

    ${mediaQueries.mobile`
      z-index: 11;
    `};
  }

  .react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
    max-height: 300px;
    overflow-y: auto;
    font-size: 14px;
  }

  .react-autosuggest__suggestion {
    cursor: pointer;
    padding: 10px;
  }

  .react-autosuggest__suggestion--highlighted {
    border-radius: 3px;
    background-color: ${({ theme }) => theme.colors.blueLighter};
  }

  .react-autosuggest__section-title {
    padding: 10px 0 5px 10px;
    font-size: 14px;
    font-family: ${({ theme }) => theme.fonts.semiBold};
    color: ${({ theme }) => theme.colors.blue};
  }
`

export const Suggestion = styled.span.attrs(props => ({
  className: `suggestion-${props.suggestionClassName}`
}))`
  color: ${({ theme }) => theme.colors.doveGray};
  padding: 0;

  svg {
    line-height: 18px;
    margin-right: 10px;
    vertical-align: bottom;
  }

  span {
    line-height: 18px;
    vertical-align: bottom;

    em {
      color: ${({ theme }) => theme.colors.blue};
      font-style: normal;
      line-height: 18px;
      vertical-align: bottom;
      font-family: ${({ theme }) => theme.fonts.semiBold};
    }
  }
`

export const ErrorMessageContainer = styled.div.attrs(props => ({
  className: `${props.name}-suggestions-not-found`
}))`
  border: 1px solid ${({ theme }) => theme.colors.red};

  border-radius: 3px;
  width: auto;
  min-width: 380px;
  margin-top: 3px;
  z-index: 2;
  position: absolute;

  ${mediaQueries.tablet`
    position: relative;
    width: 100%;
    min-width: auto;
  `};
`
